import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type FeedViewMode = 'gallery' | 'list'
export type FeedNsfwFilter = 'all' | 'sfw' | 'nsfw'

interface State {
  viewMode: FeedViewMode
  nsfwFilter: FeedNsfwFilter
  setViewMode: (m: FeedViewMode) => void
  setNsfwFilter: (f: FeedNsfwFilter) => void
}

export const useFeedViewPrefs = create<State>()(
  persist(
    (set) => ({
      viewMode: 'gallery',
      nsfwFilter: 'all',
      setViewMode: (viewMode) => set({ viewMode }),
      setNsfwFilter: (nsfwFilter) => set({ nsfwFilter }),
    }),
    { name: 'bskyhq:feedview', version: 1 },
  ),
)
